import { HiClock, HiComputerDesktop, HiLockClosed, HiSignalSlash } from 'react-icons/hi2';

const ICON_BY_REASON = {
  idle_lock: HiClock,
  session_replaced: HiComputerDesktop,
  connection_lost: HiSignalSlash,
  refresh_unreachable: HiSignalSlash
};

/**
 * Icon the reauthentication badge shows for a reason: the clock for inactivity, the desktop for an
 * account opened elsewhere, the cut signal for a lost connection and the padlock for any other.
 * @param {string} reason - Pending reauthentication reason.
 * @returns {React.ComponentType} The icon component.
 * @author armandoricosandoval -ai-
 */
export const getReauthIcon = (reason) => ICON_BY_REASON[reason] || HiLockClosed;
